import React from 'react';
import { Form, InputNumber, Row, Col, Select, Space } from 'antd';
import type { FormInstance } from 'antd';
import { RateTierDisplay } from '../../RateTierDisplay';

const { Option } = Select;

interface LogisticsParametersProps {
    selectedChannelId: string;
    setSelectedChannelId: (id: string) => void;
    channels: any[];
    loading: boolean;
    selectedChannelRateInfo: any;
    chargeableWeight: number;
    shippingCostCNY: number;
    dutyRate: number;
    setDutyRate: (rate: number) => void;
    form: FormInstance;
}

export const LogisticsParameters: React.FC<LogisticsParametersProps> = ({
    selectedChannelId,
    setSelectedChannelId,
    channels,
    loading,
    selectedChannelRateInfo,
    chargeableWeight,
    shippingCostCNY,
    dutyRate,
    setDutyRate,
    form,
}) => {
    // 尝试优先使用 useWatch，如果未获取到则尝试 getFieldValue
    const lengthWatch = Form.useWatch('length', form);
    const widthWatch = Form.useWatch('width', form);
    const heightWatch = Form.useWatch('height', form);
    const weightWatch = Form.useWatch('weight', form);

    const length = lengthWatch !== undefined ? lengthWatch : form?.getFieldValue('length');
    const width = widthWatch !== undefined ? widthWatch : form?.getFieldValue('width');
    const height = heightWatch !== undefined ? heightWatch : form?.getFieldValue('height');
    const weight = weightWatch !== undefined ? weightWatch : form?.getFieldValue('weight');

    console.log('LogisticsParameters useWatch:', { length, width, height, weight, form });

    const handleChannelChange = (channelId: string) => {
        console.log('🚚 物流方式改变:', {
            newChannelId: channelId,
            oldChannelId: selectedChannelId,
            chargeableWeight,
            channelsCount: channels.length
        });
        setSelectedChannelId(channelId);
    };

    // 在组件渲染时也打印当前的 shippingCostCNY
    React.useEffect(() => {
        console.log('💰 头程运费更新:', {
            shippingCostCNY,
            selectedChannelId,
            chargeableWeight
        });
    }, [shippingCostCNY, selectedChannelId, chargeableWeight]);

    return (
        <Row gutter={[12, 12]}>
            <Col span={8}>
                <Form.Item label="物流方式" style={{ marginBottom: 4 }}>
                    <Select
                        value={selectedChannelId ? String(selectedChannelId) : undefined}
                        onChange={handleChannelChange}
                        style={{ width: '100%' }}
                        size="small"
                        placeholder="选择渠道"
                        loading={loading}
                    >
                        {channels.map((ch: any) => (
                            <Option key={ch.id} value={String(ch.id)}>{ch.name}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <div style={{ marginBottom: 12, fontSize: 12, color: '#8c8c8c' }}>
                    <Space split="|">
                        <span>尺寸: {length || 0}x{width || 0}x{height || 0} cm</span>
                        <span>实重: {weight || 0} kg</span>
                    </Space>
                </div>

                {selectedChannelRateInfo && (
                    <RateTierDisplay
                        channelRateInfo={selectedChannelRateInfo}
                        chargeableWeight={chargeableWeight}
                    />
                )}
            </Col>
            <Col span={8}>
                <Form.Item label="头程运费(¥)" style={{ marginBottom: 12 }}>
                    <InputNumber
                        style={{ width: '100%', background: '#f5f5f5' }}
                        value={shippingCostCNY}
                        readOnly
                        precision={2}
                        size="small"
                        prefix="¥"
                    />
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item label="关税率(%)" style={{ marginBottom: 12 }}>
                    <InputNumber
                        style={{ width: '100%' }}
                        value={dutyRate}
                        onChange={(v) => setDutyRate(v || 0)}
                        precision={1}
                        size="small"
                    />
                </Form.Item>
            </Col>
        </Row>
    );
};
